'use client'
import { useTranslation } from 'react-i18next'
import { Perils } from '@/components/Perils/Perils'
import type { AddonVariantFragment } from '@/services/graphql/generated'
import { Badge } from 'ui/src/components/Badge/Badge'
import { LargeDialog } from 'ui/src/components/Dialog/LargeDialog'
import { yStack } from 'ui/src/patterns/stack'
import { sprinkles } from 'ui/src/theme/sprinkles.css'

type Props = {
  addonVariants: Array<AddonVariantFragment>
}

export function AddonCoverageDialogBody({ addonVariants }: Props) {
  const { t } = useTranslation('purchase-form')

  return (
    <div>
      <LargeDialog.Heading as="h2">{t('CAR_ADDON_COVERAGE_DIALOG_TITLE')}</LargeDialog.Heading>
      <LargeDialog.Heading as="h3" color="textSecondary" className={sprinkles({ marginBottom: 'xl' })}>
        {t('CAR_ADDON_COVERAGE_DIALOG_SUBTITLE')}
      </LargeDialog.Heading>

      <div className={yStack({ gap: 'xl' })}>
        {addonVariants.map((addon) => (
          <div key={addon.displayName}>
            <Badge as="h3" className={sprinkles({ marginBottom: 'md' })} variant="grey1" size="small">
              {addon.displayName}
            </Badge>
            <Perils items={addon.perils} />
          </div>
        ))}
      </div>
    </div>
  )
}
